import { StrategyDetailsPageCommitmentsByInvestorQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import guid from '@/shared/utils/guid';
import { formatPercentage } from '@/shared/utils/percentage';
import { TenantType } from '@trace-8/trace8-schema';
import styled from 'styled-components';

interface TabelBodyInvestorProps {
  investorTableRows: StrategyDetailsPageCommitmentsByInvestorQuery['CommitmentsByInvestor']['investors'];
  columns: TableColumns[];
  openInvestorDetailsPage: ({ investorId, entityId }: { investorId: string; entityId?: string }) => void;
}

const TabelBodyInvestor = ({ investorTableRows, columns, openInvestorDetailsPage }: TabelBodyInvestorProps) => {
  const { user } = useAuth();

  if (!investorTableRows?.length) {
    return <NoResults />;
  }

  return (
    <>
      {investorTableRows.map((row) => (
        <CustomTableRowWrapper key={guid()}>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openInvestorDetailsPage({ investorId: row.investor.id })}>
              {row.investor.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <TextCell>{row.investorEntities}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            {user && user.tenant.type === TenantType.PLATFORM_MANAGER && <TextCell>{row.tenant.name}</TextCell>}
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000}>{row.committedCapital}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000}>{row.capitalCalled}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[5].width}>
            <TextCell>{formatPercentage(row.percentOfCapitalCalled)}</TextCell>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TabelBodyInvestor;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;
